/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Container } from 'src/components/layouts/Container/Container';
import HeadlineWithButtons from 'src/components/ui/HeadlineWithButtons/HeadlineWithButtons';
import { useTranslation } from 'react-i18next';
import Stepper from 'src/components/ui/Stepper/Stepper';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import Divider from 'src/components/ui/Divider/Divider';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/Inventory.module.scss';
import { ActionBar, ReturnsConfiguratorForm, Section } from './ReturnsConfiguratorForm';

interface ReturnCreateShellProps {
  step?: number;
  title: string;
  headline: string;
  children: React.ReactNode;
}

export const ReturnsCreateShell: React.FC<ReturnCreateShellProps> = ({ step, children, headline, title }) => {
  const { t } = useTranslation();

  return (
    <Container buttons={[]} className={classNames(styles.root)} title={title}>
      <HeadlineWithButtons headline={headline} buttons={[]} />
      {Number.isInteger(step) && (
        <div className="mt-40 mb-40 grid gap-y-24 px-32">
          <Stepper
            currentStep={step!}
            totalSteps={4}
            stepLabels={[t('returns.tracking'), t('returns.products'), t('returns.summary'), t('returns.done')]}
          />
        </div>
      )}
      {children}
    </Container>
  );
};

function ReturnsCreateTracking() {
  const { t } = useTranslation();
  const [disableNextButton, setDisableNextButton] = useState(true);

  const formRef = useRef<{ triggerSubmit: () => void }>(null);

  const submit = () => {
    if (formRef.current) {
      formRef.current.triggerSubmit();
    }
  };

  const navigate = useNavigate();

  return (
    <ReturnsCreateShell step={1} title={t('navbar.returns')} headline={t('navbar.create_return')}>
      <div className="grid gap-y-20">
        <Section className="flex flex-col gap-y-32">
          <ReturnsConfiguratorForm
            ref={formRef}
            onSubmit={() => {
              navigate('/returns/create/products');
            }}
            step={1}
            setDisableNextButton={setDisableNextButton}
          />
          <Divider className="" />
          <ActionBar>
            <Button
              title={t('general.cancel')}
              onClick={() => {
                navigate('/returns');
              }}
              tone={ButtonToneProps.SECONDARY}
            />
            <Button
              title={t('general.continue')}
              onClick={submit}
              tone={ButtonToneProps.PRIMARY_BLUE}
              disabled={disableNextButton}
            />
          </ActionBar>
        </Section>
      </div>
    </ReturnsCreateShell>
  );
}

export default ReturnsCreateTracking;
